import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Dynamically updates page title and favicon based on route and optional Nifty data.
 */
export default function usePageTitle(price = "", expiry = "") {
  const location = useLocation();

  useEffect(() => {
    let title = "noptionwave";
    const path = location.pathname;

    switch (true) {
      case path.includes("/login"):
        title = "NOW | Login";
        break;
      case path.includes("/signup"):
        title = "NOW | Signup";
        break;
      case path.includes("/dashboard"):
        title = "NOW | Dashboard";
        break;
      case path.includes("/nifty-option-chain"):
        title = `Nifty | ${price ? " " + price : ""}${expiry ? " | " + expiry : ""}`;
        break;
      case path.includes("/banknifty-option-chain"):
        title = `Banknifty | ${price ? " " + price : ""}${expiry ? " | " + expiry : ""}`;
        break;
      case path.includes("/finnifty-option-chain"):
        title = `Finnifty | ${price ? " " + price : ""}${expiry ? " | " + expiry : ""}`;
        break;
      case path.includes("/midcpnifty-option-chain"):
        title = `Midcpnifty | ${price ? " " + price : ""}${expiry ? " | " + expiry : ""}`;
        break;
      case path.includes("/subscribe"):
        title = "NOW | Subscribe";
        break;
      case path.includes("/profile"):
        title = "NOW | Profile";
        break;
      case path.includes("/stock-api-day-range-data"):
        title = "NOW | Stock Data";
        break;
        case path.includes("/stock-data-analysis"):
        title = "NOW | Stock Data Analysis";
        break;
        case path.includes("/fyers-access-token"):
        title = "NOW | Fyers Access Token";
        break;
      case path.includes("/nse-option-chain"):
        title = `NOW | ${price ? " " + price : ""}${expiry ? " | " + expiry : ""}`;
        break;
      case path.includes("/hedging-strategy"):
        title = `NOW | ${price ? " " + price : ""}${expiry ? " | " + expiry : ""}`;
        break;
      case path.includes("/stock-sector-analysis"):
        title = "NOW | Sector Data Analysis";
        break;
      default:
        title = "noptionwave";
    }

    document.title = title;

    // ✅ Favicon logic
    const head = document.head;

    // Safely remove all existing favicon links
    document.querySelectorAll("link[rel*='icon']").forEach((icon) => icon.remove());

    // Create and append a new favicon link
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    link.sizes = "512x512";
    link.href = `${process.env.PUBLIC_URL}/assets/images/web-app-manifest-512.png`; // ✅ correct path & name
    head.appendChild(link);

    // console.log("✅ Page title set =>", title);
  }, [location, price, expiry]);
}
